import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { WorkoutInfo } from '../../containers/Workouts';
import Grid from '@material-ui/core/Grid';
import { COLORS } from '../../styles/colors';

/**
 * Info
 */
function Preview(props) {
    const { match: { params: { id } }, user: { type } } = props;
    const assignLink = type.includes('brand') || type.includes('corporate') ? '/assign/featured-brand' : '/assign/clients';
    const assignText = type.includes('brand') || type.includes('corporate') ? ` your workout to your featured brand page` : `your workout to your clients or partners`;
    useEffect(() => window.scrollTo(0, 0), []);
    if (id !== '') {
        return (
            <div>
                <h1>Workout Complete! Preview Mode</h1>
                <hr />
                <Fragment>
                    <Grid container alignItems="flex-start" style={{
                        'paddingTop': '60px',
                        'position': 'relative'
                    }}>
                        <div className="smartphone-left">
                            <div><strong>Next Steps:</strong></div>
                            <ul>
                                <li>Review the workout you just built</li>
                                <li>Make any correction in your
                                    <Link to="/library/workouts">
                                        <span style={{ color: COLORS.orange }}> Library</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={assignLink}>
                                        <span style={{ color: COLORS.orange }}> Assign</span>
                                    </Link>
                                    {' '}{assignText}
                                </li>
                            </ul>
                        </div>
                        <div className="divider"></div>
                        <div className="smartphone">
                            <div className="content">
                                <WorkoutInfo workoutId={id} />
                            </div>
                        </div>
                    </Grid>
                </Fragment>
            </div>
        );
    } else {
        return null;
    }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/workouts/Preview.js